import Vue from 'vue'
import VueIntersect from 'vue-intersect-directive/dist/vue-intersect-directive.esm.js'

Vue.use(VueIntersect)
